import { useEffect } from "react";
import { msalInstance } from "./authUtil";
import { makeLogEvent } from '../api/EventLog';
import * as storage from './StorageUtil';


const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const inactivityTimer = 1800000; // 30 * 60 * 1000 ms = 30 min

const IdleHandler = ({ children }) => {
    let timer;

    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleTimer();
            });
        });
    });

    const resetTimer = () => {
    if (timer) clearTimeout(timer);
    };

    const handleTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {

                window.removeEventListener(item, resetTimer);
            });
            logoutAction();
        }, inactivityTimer);
    };

    const logoutAction = async () => {
        console.log("IdleHandler: Logging out...");
        const account = msalInstance.getActiveAccount();
        if (account) {
            const name = account?.name;
            const role = account?.idTokenClaims?.roles ? account?.idTokenClaims?.roles[0] : "none";
            await makeLogEvent(`User ${name} logged out due to inactivity`, "login", `Role: ${role}`);
            storage.clearStore(); // Forgot last user and other data...
            const logoutRequest = {
            account
            }
            msalInstance.logoutRedirect(logoutRequest);
        }
    };
  return children;
};

export default IdleHandler;